import React from 'react'
import { Col, Row } from 'react-bootstrap'
import MainHeading from '../../aboutus/mainheading'
import { Link } from 'react-router-dom'
import './customerhero.scss'
import { images } from '../../../utils/customFn'
const CustomerHero = () => {
    return (
        <div className='customerhero'>
            <Row>
                <Col md={6} sm={12}>
                    <MainHeading title="Customer tools and resources" showshare={false}/>
                    <div className='common-heading'>
                        <h2>Self-service options for efficient account management</h2>
                    </div>
                    <div className='text'>
                        <p>Use the quick links below to perform important tasks without logging in to your Sentry customer account.
                            To access our full range of policy management tools and other resources, just log in to your account.</p>
                    </div>
                    <div className='loginbtn'>
                        <Link to='' className='link primaryButtonLink'>Log in</Link>
                    </div>
                </Col>
                <Col md={6} sm={12}>
                <div className='hero-img'>
                    <img src={images['working_on_laptop.avif']}/>
                </div>
                </Col>
            </Row>
        </div>
    )
}

export default CustomerHero
